var BookAppointmentFormLayout = /* @__PURE__ */ ((BookAppointmentFormLayout2) => {
  BookAppointmentFormLayout2["DEFAULT"] = "DEFAULT";
  BookAppointmentFormLayout2["CHILD"] = "CHILD";
  return BookAppointmentFormLayout2;
})(BookAppointmentFormLayout || {});
export {
  BookAppointmentFormLayout
};
//# sourceMappingURL=Forms.js.map
